var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavProfileActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.8841C0 16.6217 4.6125 15.8061 10 15.8061C15.3875 15.8061 20 16.6457 20 19.908C20 23.1704 15.3875 23.986 10 23.986C4.6125 23.986 0 23.1464 0 19.8841ZM3.38753 6.35484C3.38753 5.09995 3.77529 3.87324 4.50188 2.82984C5.22847 1.78644 6.26121 0.973196 7.46948 0.492971C8.67776 0.0127459 10.0074 -0.112896 11.2901 0.131921C12.5728 0.376738 13.751 0.981017 14.6758 1.86836C15.6005 2.7557 16.2303 3.88623 16.4854 5.117C16.7406 6.34778 16.6096 7.62352 16.1092 8.78288C15.6087 9.94225 14.7611 10.9332 13.6737 11.6304C12.5863 12.3275 11.3078 12.6996 10 12.6996C9.13387 12.7028 8.27559 12.542 7.47429 12.2265C6.67298 11.9111 5.94439 11.447 5.3302 10.861C4.71601 10.2751 4.22823 9.5786 3.89488 8.81154C3.56153 8.04448 3.38916 7.22189 3.38753 6.39082V6.35484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProfileActive);
export default __webpack_public_path__ + "static/media/nav-profile-active.ad4490b1317fd66492bb23a957de856e.svg";
export { ForwardRef as ReactComponent };